import axios from '@/libs/api.request'

export const DeleteMeterLog = data => {
  return axios.request({
    url: '/print/meter/delete',
    data,
    method: 'put'
  })
}
export const SaveMeterCharge = data => {
  return axios.request({
    url: '/print/meter/charge',
    data,
    method: 'put'
  })
}
export const GetMeterCharge = data => {
  return axios.request({
    url: '/print/meter/charge',
    params: data,
    method: 'get'
  })
}
export const GetMeterChargeDetail = data => {
  return axios.request({
    url: '/print/meter/charge/detail',
    params: data,
    method: 'get'
  })
}
export const GetMeterLog = data => {
  return axios.request({
    url: '/print/meter/log',
    params: data,
    method: 'get'
  })
}
export const GetMeterMachine = data => {
  return axios.request({
    url: '/print/meter/machine',
    params: data,
    method: 'get'
  })
}
export const PutMeter = data => {
  return axios.request({
    url: '/print/meter/log',
    data,
    method: 'put'
  })
}
export const GetMeterOrderMachine = data => {
  return axios.request({
    url: '/print/meter/order/machine',
    params: data,
    method: 'get'
  })
}
export const GetAgentMeter = data => {
  return axios.request({
    url: '/print/meter/agent_log',
    params: data,
    method: 'get'
  })
}
export const GetMeterChargesByMachineId = data => {
  return axios.request({
    url: '/print/meter/charges',
    params: data,
    method: 'get'
  })
}
export const PutMeterResult = data => {
  return axios.request({
    url: '/print/meter/result',
    data,
    method: 'put'
  })
}
export const GetMeterResult = data => {
  return axios.request({
    url: '/print/meter/result',
    params: data,
    method: 'get'
  })
}
export const GetLastMeter = data => {
  return axios.request({
    url: '/print/meter/result/last',
    params: data,
    method: 'get'
  })
}
export const MeterRegain = data => {
  return axios.request({
    url: '/print/meter/log/regain',
    data,
    method: 'put'
  })
}

export const GetMeterQrCode = data => {
  return axios.request({
    url: '/print/meter/qrcode',
    params: data,
    method: 'get'
  })
}

export const SaveMeterQrcode = data => {
  return axios.request({
    url: '/print/meter/qrcode',
    data,
    method: 'post'
  })
}

export const GetMeterMachineList = params => {
  return axios.request({
    url: '/print/meter/qrcode/machine',
    params,
    method: 'get'
  })
}
export const GetPreMeterData = data => {
  return axios.request({
    url: '/print/meter/pre/data',
    data,
    method: 'post'
  })
}
export const PutMeterManual = params => {
  return axios.request({
    url: '/print/meter/pre/manual',
    data: params,
    method: 'post'
  })
}
export const DelMeterResult = data => {
  return axios.request({
    url: '/print/meter/result/del',
    data,
    method: 'post'
  })
}
